import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import './CompletionScreen.css';

function CompletionScreen({ onNewTimer, onLock }) {
  useEffect(() => {
    // Trigger confetti celebration
    const duration = 3000;
    const end = Date.now() + duration;

    const colors = ['#7EC8E3', '#8EC9A9', '#D4AF37', '#B8201E'];

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
  }, []);

  return (
    <div className="completion-screen" data-testid="completion-screen">
      <div className="completion-container scale-in">
        <div className="completion-content">
          <h1 className="completion-title" data-testid="completion-message">
            Jetzt geht es los!
          </h1>
          
          <div className="completion-actions">
            <button
              className="new-timer-button"
              onClick={onNewTimer}
              data-testid="new-timer-button"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="12 6 12 12 16 14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Neuer Timer
            </button>
            
            <button
              className="lock-button-completion"
              onClick={onLock}
              data-testid="lock-button-completion"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Sperren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompletionScreen;